import { Grid } from "@mui/material";

import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";

export const RaffleTokenSearchForm = () => {
  return (
    <SearchWithFilters initialValues={{ roundIds: [] }}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 12 }}>
          <EntityInput multiple name="roundIds" controller="raffle/rounds" />
        </Grid>
      </Grid>
    </SearchWithFilters>
  );
};
